import React, { PureComponent } from 'react';
export default class CellLabel extends PureComponent {
    render() {
        const { className, onClick, onDoubleClick, value } = this.props;
        return (React.createElement("div", { className: className, onClick: onClick, onDoubleClick: onDoubleClick }, value));
    }
}
